import { d as Ht, C as $t } from "./component-CAYPdBLR.js";
function K(n) {
  return (t) => n(bt(t) ? t : t.get());
}
function bt(n) {
  return typeof n == "number";
}
function It(n) {
  return typeof n == "string";
}
function Pt(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function V(n) {
  return Math.abs(n);
}
function St(n) {
  return Math.sign(n);
}
function ft(n, t) {
  return V(n - t);
}
function Gt(n, t) {
  if (n === 0 || t === 0 || V(n) <= V(t)) return 0;
  const c = ft(V(n), V(t));
  return V(c / n);
}
function Rt(n) {
  return Math.round(n * 100) / 100;
}
function dt(n) {
  return gt(n).map(Number);
}
function et(n) {
  return n[pt(n)];
}
function pt(n) {
  return Math.max(0, n.length - 1);
}
function vt(n, t) {
  return t === pt(n);
}
function Nt(n, t = 0) {
  return Array.from(Array(n - t + 1), (c, e) => t + e);
}
function gt(n) {
  return Object.keys(n);
}
function Bt(n, t) {
  return [n, t].reduce(
    (c, e) => (
      gt(e).forEach((s) => {
        const o = c[s],
          i = e[s],
          l = Pt(o) && Pt(i);
        c[s] = l ? Bt(o, i) : i;
      }),
      c
    ),
    {}
  );
}
function Tt(n, t) {
  return typeof t.MouseEvent < "u" && n instanceof t.MouseEvent;
}
function jt(n, t) {
  const c = { start: e, center: s, end: o };
  function e() {
    return 0;
  }
  function s(u) {
    return o(u) / 2;
  }
  function o(u) {
    return t - u;
  }
  function i(u, d) {
    return It(n) ? c[n](u) : n(t, u, d);
  }
  return { measure: i };
}
function ht() {
  let n = [];
  function t(s, o, i, l = { passive: !0 }) {
    let u;
    if ("addEventListener" in s)
      (s.addEventListener(o, i, l), (u = () => s.removeEventListener(o, i, l)));
    else {
      const d = s;
      (d.addListener(i), (u = () => d.removeListener(i)));
    }
    return (n.push(u), e);
  }
  function c() {
    n = n.filter((s) => s());
  }
  const e = { add: t, clear: c };
  return e;
}
function qt(n, t) {
  const c = ht(),
    e = 1e3 / 60;
  let s,
    o = null,
    i = 0,
    l = 0;
  function u(a) {
    const f = a.document;
    ((s = a),
      c.add(f, "visibilitychange", () => {
        f.hidden && p();
      }));
  }
  function d() {
    (r(), c.clear());
  }
  function b(a) {
    if (!l) return;
    o || ((o = a), n(), n());
    const f = a - o;
    for (o = a, i += f; i >= e; ) (n(), (i -= e));
    const m = i / e;
    (t(m), l && (l = s.requestAnimationFrame(b)));
  }
  function g() {
    l || (l = s.requestAnimationFrame(b));
  }
  function r() {
    l && (s.cancelAnimationFrame(l), (o = null), (i = 0), (l = 0));
  }
  function p() {
    ((o = null), (i = 0));
  }
  return { init: u, destroy: d, start: g, stop: r, update: n, render: t };
}
function zt(n, t) {
  const c = t === "rtl",
    e = n === "y",
    s = e ? "y" : "x",
    o = e ? "x" : "y",
    i = !e && c ? -1 : 1,
    l = g(),
    u = r(),
    d = e ? "scrollTop" : "scrollLeft";
  function b(a) {
    const { height: f, width: m } = a;
    return e ? f : m;
  }
  function g() {
    return e ? "top" : c ? "right" : "left";
  }
  function r() {
    return e ? "bottom" : c ? "left" : "right";
  }
  function p(a) {
    return a * i;
  }
  return {
    scroll: s,
    cross: o,
    startEdge: l,
    endEdge: u,
    nativeScroll: d,
    getSize: b,
    direction: K(p),
  };
}
function ct(n = 0, t = 0) {
  const c = V(n - t);
  function e(d) {
    return d < n;
  }
  function s(d) {
    return d > t;
  }
  function o(d) {
    return e(d) || s(d);
  }
  function i(d) {
    return o(d) ? (e(d) ? n : t) : d;
  }
  function l(d) {
    return c ? d - c * Math.ceil((d - t) / c) : d;
  }
  return {
    length: c,
    max: t,
    min: n,
    clamp: K(i),
    pastAnyBound: K(o),
    pastMaxBound: K(s),
    pastMinBound: K(e),
    removeOffset: K(l),
  };
}
function Dt(n, t, c) {
  const { clamp: e } = ct(0, n),
    s = n + 1;
  let o = i(t);
  function i(r) {
    return c ? V((s + r) % s) : e(r);
  }
  function l() {
    return o;
  }
  function u(r) {
    return ((o = i(r)), g);
  }
  function d(r) {
    return b().set(l() + r);
  }
  function b() {
    return Dt(n, l(), c);
  }
  const g = { get: l, set: u, add: d, clone: b };
  return g;
}
function Ut(n, t, c, e, s, o, i, l, u, d, b, g, r, p, h, a, f) {
  const { cross: m, direction: y } = t,
    v = ["INPUT", "SELECT", "TEXTAREA"],
    w = { passive: !1 },
    x = ht(),
    L = ht(),
    E = ct(50, 225).clamp(r.measure(20)),
    T = { mouse: 300, touch: 400 },
    O = { mouse: 500, touch: 600 },
    M = p ? 43 : 25;
  let N,
    F,
    H = !1,
    A = 0,
    P = 0,
    D = !1,
    k = !1,
    z = !1,
    G = !1,
    $ = !1;
  function X(S) {
    if (!n) return;
    ((N = S.document), (F = S), s.init(S));
    const I = c;
    x.add(I, "dragstart", (B) => B.preventDefault(), w)
      .add(I, "touchmove", (B) => D && Y(B), w)
      .add(I, "touchend", (B) => D && Q(B))
      .add(I, "touchstart", tt)
      .add(I, "mousedown", tt)
      .add(I, "touchcancel", Q)
      .add(I, "contextmenu", Q)
      .add(I, "click", at, !0);
  }
  function J() {
    (x.clear(), L.clear(), (D = !1));
  }
  function q() {
    const S = $ ? N : c;
    L.add(S, "mousemove", Y, w).add(S, "mouseup", Q);
  }
  function Z(S) {
    const I = S.nodeName || "";
    return v.includes(I);
  }
  function R() {
    return (p ? O : T)[$ ? "mouse" : "touch"];
  }
  function ot() {
    return d.byDistance(0, !1).index !== b.get();
  }
  function lt(S) {
    return d.byDistance(S, !p).distance;
  }
  function _(S) {
    const I = b.add(St(S) * -1);
    return p || V(S) < E ? lt(S) : a && ot() ? lt(S) * 0.5 : d.byIndex(I.get(), 0).distance;
  }
  function tt(S) {
    if (!g.createEvent("pointerdown", S).emit()) return;
    const j = Tt(S, F),
      U = j && S.button !== 0;
    (($ = j),
      (G = p && j && !S.buttons && H),
      (H = ft(e.get(), o.get()) >= 2),
      !U &&
        (Z(S.target) ||
          ((k = !0),
          s.pointerDown(S),
          u.useFriction(0).useDuration(0),
          e.set(o),
          (A = s.readPoint(S)),
          (P = s.readPoint(S, m)),
          q(),
          (D = !0))));
  }
  function Y(S) {
    if (!g.createEvent("pointermove", S).emit() || (!Tt(S, F) && S.touches.length >= 2))
      return Q(S);
    const W = s.readPoint(S),
      st = s.readPoint(S, m),
      it = ft(W, A),
      mt = ft(st, P);
    if (!z && !$ && (!S.cancelable || ((z = it > mt), !z))) return Q(S);
    const rt = s.pointerMove(S);
    (it > h && (G = !0),
      u.useFriction(0.3).useDuration(0.75),
      i.start(),
      e.add(y(rt)),
      S.cancelable && S.preventDefault());
  }
  function Q(S) {
    const I = g.createEvent("pointerup", S),
      B = s.pointerUp(S) * R(),
      j = _(y(B)),
      U = Gt(B, j),
      W = M - 10 * U,
      st = f + U / 50;
    ((z = !1),
      (k = !1),
      (D = !1),
      ($ = !1),
      L.clear(),
      u.useDuration(W).useFriction(st),
      l.distance(j, !p),
      I.emit());
  }
  function at(S) {
    G && (S.stopPropagation(), S.preventDefault(), (G = !1));
  }
  function nt() {
    return k;
  }
  return { init: X, destroy: J, pointerDown: nt };
}
function Wt(n) {
  let c, e, s;
  function o(r) {
    c = r;
  }
  function i(r) {
    return r.timeStamp;
  }
  function l(r, p) {
    const a = `client${(p || n.scroll) === "x" ? "X" : "Y"}`;
    return (Tt(r, c) ? r : r.touches[0])[a];
  }
  function u(r) {
    return ((e = r), (s = r), l(r));
  }
  function d(r) {
    const p = l(r) - l(s),
      h = i(r) - i(e) > 170;
    return ((s = r), h && (e = r), p);
  }
  function b(r) {
    if (!e || !s) return 0;
    const p = l(s) - l(e),
      h = i(r) - i(e),
      a = i(r) - i(s) > 170,
      f = p / h;
    return h && !a && V(f) > 0.1 ? f : 0;
  }
  return { init: o, pointerDown: u, pointerMove: d, pointerUp: b, readPoint: l };
}
function Kt(n) {
  function t(e) {
    return n * (e / 100);
  }
  return { measure: t };
}
function Qt(n, t, c, e, s, o) {
  const i = [t, ...e];
  let l,
    u,
    d = [],
    b = !1;
  function g(f) {
    return s.getSize(o.getRect(f));
  }
  function r(f) {
    n &&
      ((u = g(t)),
      (d = e.map(g)),
      (l = new f.ResizeObserver(h)),
      f.requestAnimationFrame(() => {
        i.forEach((m) => l.observe(m));
      }));
  }
  function p() {
    ((b = !0), l && l.disconnect());
  }
  function h(f) {
    const m = c.createEvent("resize", f);
    if (m.emit())
      for (const v of f) {
        if (b) return;
        const w = v.target === t,
          x = e.indexOf(v.target),
          L = w ? u : d[x],
          E = g(w ? t : e[x]);
        if (V(E - L) >= 0.5) {
          m.api.reInit();
          break;
        }
      }
  }
  return { init: r, destroy: p };
}
function Xt() {
  function n(e) {
    const {
      dragHandler: s,
      scrollBody: o,
      scrollBounds: i,
      options: { loop: l },
    } = e;
    (l || i.constrain(s.pointerDown()), o.seek());
  }
  function t(e, s) {
    const {
        scrollBody: o,
        translate: i,
        location: l,
        offsetLocation: u,
        previousLocation: d,
        scrollLooper: b,
        slideLooper: g,
        dragHandler: r,
        animation: p,
        eventHandler: h,
        scrollBounds: a,
        scrollOptimizer: f,
        options: { loop: m },
      } = e,
      y = o.settled(),
      v = !a.shouldConstrain(),
      w = r.pointerDown(),
      L = y && (m || v),
      E = !L,
      T = E && w,
      O = L && !w;
    O && (f.optimize(O), p.stop());
    const M = l.get() * s + d.get() * (1 - s);
    (u.set(M),
      m && (b.loop(o.direction()), g.loop()),
      i.to(u),
      f.optimize(),
      O && h.createEvent("settle", null).emit(),
      E && h.createEvent("scroll", { isDragging: T }).emit());
  }
  return { update: n, render: t };
}
function _t(n, t, c, e, s, o) {
  let i = 0,
    l = 0,
    u = s,
    d = o,
    b = n.get(),
    g = 0;
  function r() {
    const L = e.minus(n),
      E = !u;
    let T = 0;
    return (
      E
        ? ((i = 0), c.set(e), n.set(e), (T = L))
        : (c.set(n), (i += L / u), (i *= d), (b += i), n.add(i), (T = b - g)),
      (l = St(T)),
      (g = b),
      x
    );
  }
  function p() {
    const L = e.minus(t);
    return V(L) < 0.001;
  }
  function h() {
    return u;
  }
  function a() {
    return l;
  }
  function f() {
    return i;
  }
  function m() {
    return v(s);
  }
  function y() {
    return w(o);
  }
  function v(L) {
    return ((u = L), x);
  }
  function w(L) {
    return ((d = L), x);
  }
  const x = {
    direction: a,
    duration: h,
    velocity: f,
    seek: r,
    settled: p,
    useBaseFriction: y,
    useBaseDuration: m,
    useFriction: w,
    useDuration: v,
  };
  return x;
}
function Yt(n, t, c, e, s) {
  const { pastAnyBound: o, pastMinBound: i, clamp: l } = n,
    u = s.measure(10),
    d = s.measure(50),
    b = ct(0.1, 0.99);
  let g = !1;
  function r() {
    return !(g || !o(c) || !o(t));
  }
  function p(f) {
    if (!r()) return;
    const m = i(t) ? "min" : "max",
      y = V(n[m] - t.get()),
      v = c.minus(t),
      w = b.clamp(y / d);
    (c.subtract(v * w), !f && V(v) < u && (c.set(l(c)), e.useDuration(25).useBaseFriction()));
  }
  function h(f) {
    g = !f;
  }
  return { shouldConstrain: r, constrain: p, toggleActive: h };
}
function Jt(n, t, c, e, s) {
  const o = ct(-t + n, 0),
    i = g(),
    l = b(),
    u = r();
  function d(h, a) {
    return s ? ft(h, a) <= 1 : !1;
  }
  function b() {
    const h = i[0],
      a = et(i),
      f = i.lastIndexOf(h),
      m = i.indexOf(a) + 1;
    return ct(f, m);
  }
  function g() {
    return c
      .map((h, a) => {
        const { min: f, max: m } = o,
          y = o.clamp(h),
          v = !a,
          w = vt(c, a);
        return v ? m : w || d(f, y) ? f : d(m, y) ? m : y;
      })
      .map((h) => parseFloat(h.toFixed(3)));
  }
  function r() {
    if (t <= n + s) return [o.max];
    if (e === "keepSnaps") return i;
    const { min: h, max: a } = l;
    return i.slice(h, a);
  }
  return { snapsContained: u, scrollContainLimit: l };
}
function Zt(n, t, c) {
  const e = t[0],
    s = c ? e - n : et(t);
  return { limit: ct(s, e) };
}
function te(n, t, c, e) {
  const o = t.min + 0.1,
    i = t.max + 0.1,
    { pastMinBound: l, pastMaxBound: u } = ct(o, i);
  function d(r) {
    return r === 1 ? u(c) : r === -1 ? l(c) : !1;
  }
  function b(r) {
    if (!d(r)) return;
    const p = n * (r * -1);
    e.forEach((h) => h.add(p));
  }
  return { loop: b };
}
function ee(n) {
  const { max: t, length: c } = n;
  function e(o) {
    const i = o - t;
    return c ? i / -c : 0;
  }
  return { get: K(e) };
}
function ne(n, t, c, e, s) {
  const { startEdge: o, endEdge: i } = n,
    { groupSlides: l } = s,
    u = g().map(t.measure),
    d = r(),
    b = p();
  function g() {
    return l(e)
      .map((a) => et(a)[i] - a[0][o])
      .map(V);
  }
  function r() {
    return e.map((a) => c[o] - a[o]).map((a) => -V(a));
  }
  function p() {
    return l(d)
      .map((a) => a[0])
      .map((a, f) => a + u[f]);
  }
  return { snaps: d, snapsAligned: b };
}
function se(n, t, c, e, s, o, i) {
  const { groupSlides: l } = s,
    { min: u, max: d } = e,
    b = h(),
    g = a(),
    r = c.map(i.get),
    p = c.length;
  function h() {
    const m = l(o),
      y = !n || t === "keepSnaps";
    return c.length === 1
      ? [o]
      : y
        ? m
        : m.slice(u, d).map((v, w, x) => {
            const L = !w,
              E = vt(x, w);
            if (L) {
              const T = et(v);
              return Nt(T);
            }
            if (E) {
              const T = pt(o);
              return Nt(T, v[0]);
            }
            return v;
          });
  }
  function a() {
    const m = {};
    return (
      b.forEach((y, v) => {
        y.forEach((w) => {
          m[w] = v;
        });
      }),
      m
    );
  }
  return { slidesBySnap: b, snapBySlide: g, progressBySnap: r, length: p };
}
function ie(n, t, c, e, s) {
  const { pastAnyBound: o, removeOffset: i, clamp: l } = e;
  function u(h) {
    return h.sort((a, f) => V(a) - V(f))[0];
  }
  function d(h) {
    const a = n ? i(h) : l(h),
      { index: f } = t.reduce(
        (m, y, v) => {
          const w = V(b(y - a, 0));
          return w >= m.smallestDisplacement ? m : { smallestDisplacement: w, index: v };
        },
        { smallestDisplacement: 1 / 0, index: 0 }
      );
    return { index: f, distance: a };
  }
  function b(h, a) {
    if (!n) return h;
    const f = [h, h + c, h - c];
    if (!a) return u(f);
    const m = f.filter((y) => St(y) === a);
    return m.length ? u(m) : et(f) - c;
  }
  function g(h, a) {
    const f = t[h] - s.get(),
      m = b(f, a);
    return { index: h, distance: m };
  }
  function r(h, a) {
    const f = s.plus(h),
      { index: m, distance: y } = d(f),
      v = !n && o(f);
    if (!a || v) return { index: m, distance: h };
    const w = t[m] - y,
      x = h + b(w, 0);
    return { index: m, distance: x };
  }
  return { byDistance: r, byIndex: g, shortcut: b };
}
function oe(n, t, c, e, s, o, i) {
  function l(r) {
    const { index: p, distance: h } = r,
      a = t.get(),
      f = p !== a;
    (h && (o.add(h), e.duration() ? n.start() : (n.update(), n.render(1), n.update())),
      f && (c.set(a), t.set(p), i.createEvent("select", { targetSnap: p, sourceSnap: a }).emit()));
  }
  function u(r, p) {
    const h = s.byDistance(r, p);
    l(h);
  }
  function d(r, p) {
    const h = t.clone().set(r).get(),
      a = s.byIndex(h, b(p));
    l(a);
  }
  function b(r) {
    return r ? (bt(r) ? r : r === "forward" ? -1 : 1) : 0;
  }
  return { distance: u, index: d };
}
function re(n, t, c, e, s, o, i, l, u) {
  const d = { passive: !0, capture: !0 };
  let b = 0;
  function g(a) {
    t &&
      (l.add(a.document, "keydown", p, !1),
      e.forEach((f, m) => {
        l.add(f, "focus", (y) => r(y, m), d);
      }));
  }
  function r(a, f) {
    if (new Date().getTime() - b > 10 || !u.createEvent("slidefocus", a).emit()) return;
    c[n.nativeScroll] = 0;
    const x = s.snapBySlide[f];
    bt(x) && (i.useDuration(0), o.index(x, 0));
  }
  function p(a) {
    a.code === "Tab" && (b = new Date().getTime());
  }
  return { init: g };
}
function ut(n) {
  let t = n || 0;
  function c() {
    return t;
  }
  function e(d) {
    t = d;
  }
  function s(d) {
    t += d;
  }
  function o(d) {
    s(-d);
  }
  function i(d) {
    return t + d;
  }
  function l(d) {
    return i(-d);
  }
  return { get: c, set: K(e), add: K(s), subtract: K(o), plus: K(i), minus: K(l) };
}
function ce(n, t, c, e, s, o, i, l) {
  const d = dt(e),
    b = dt(e).reverse(),
    g = f().concat(m());
  function r(x, L) {
    return x.reduce((E, T) => E - e[T], L);
  }
  function p(x, L) {
    return x.reduce((E, T) => (r(E, L) > 0 ? [...E, T] : E), []);
  }
  function h(x) {
    return s.map((L, E) => ({ start: L - c[E] + 0.5 + x, end: L + n - 0.5 + x }));
  }
  function a(x, L, E) {
    const T = h(L);
    return x.map((O) => {
      const M = E ? 0 : -t,
        N = E ? t : 0,
        F = E ? "end" : "start",
        H = T[O][F];
      return {
        index: O,
        loopPoint: H,
        slideLocation: ut(-1),
        translate: l[O],
        target: () => (i.get() > H ? M : N),
      };
    });
  }
  function f() {
    const x = o[0],
      L = p(b, x);
    return a(L, t, !1);
  }
  function m() {
    const x = n - o[0] - 1,
      L = p(d, x);
    return a(L, -t, !0);
  }
  function y() {
    return g.every(({ index: x }) => {
      const L = d.filter((E) => E !== x);
      return r(L, n) <= 0.1;
    });
  }
  function v() {
    g.forEach((x) => {
      const { target: L, translate: E, slideLocation: T } = x,
        O = L();
      O !== T.get() && (E.to(O), T.set(O));
    });
  }
  return { canLoop: y, loop: v, loopPoints: g };
}
function le(n, t, c) {
  let e,
    s = !1;
  function o(d) {
    n && ((e = new d.MutationObserver(l)), e.observe(t, { childList: !0 }));
  }
  function i() {
    (e && e.disconnect(), (s = !0));
  }
  function l(d) {
    const b = c.createEvent("slideschanged", d);
    if (b.emit())
      for (const r of d) {
        if (s) return;
        if (r.type === "childList") {
          b.api.reInit();
          break;
        }
      }
  }
  return { init: o, destroy: i };
}
function ae(n, t, c, e, s) {
  const o = new Set();
  let i,
    l = !1;
  function u(p) {
    ((i = new p.IntersectionObserver(b, { root: n.parentElement, threshold: e, rootMargin: s })),
      t.forEach((h) => i.observe(h)));
  }
  function d() {
    (i && i.disconnect(), (l = !0));
  }
  function b(p) {
    const h = [],
      a = [];
    for (const m of p) {
      if (l) return;
      const y = t.indexOf(m.target);
      m.isIntersecting ? (o.add(y), h.push(y)) : (o.delete(y), a.push(y));
    }
    c.createEvent("slidesinview", {
      slidesInView: g(),
      slidesLeftView: a,
      slidesEnterView: h,
    }).emit();
  }
  function g() {
    return [...o];
  }
  return { init: u, destroy: d, get: g };
}
function ue(n, t, c, e, s, o) {
  const { ownerWindow: i } = o,
    { getSize: l, startEdge: u, endEdge: d } = n,
    b = c[0] && s && i,
    g = a(),
    r = f(),
    p = c.map(l),
    h = m();
  function a() {
    if (!b) return 0;
    const v = c[0];
    return V(t[u] - v[u]);
  }
  function f() {
    if (!b) return 0;
    const v = i.getComputedStyle(et(e));
    return parseFloat(v.getPropertyValue(`margin-${d}`));
  }
  function m() {
    return c
      .map((v, w, x) => {
        const L = !w,
          E = vt(x, w);
        return L ? p[w] + g : E ? p[w] + r : x[w + 1][u] - v[u];
      })
      .map(V);
  }
  return { slideSizes: p, slideSizesWithGaps: h, startGap: g, endGap: r };
}
function fe(n, t, c, e, s, o, i, l, u) {
  const { startEdge: d, endEdge: b, direction: g } = n,
    r = bt(c);
  function p(m, y) {
    return dt(m)
      .filter((v) => v % y === 0)
      .map((v) => m.slice(v, v + y));
  }
  function h(m) {
    return m.length
      ? dt(m)
          .reduce((y, v, w) => {
            const x = et(y) || 0,
              L = x === 0,
              E = v === pt(m),
              T = s[d] - o[x][d],
              O = s[d] - o[v][b],
              M = !e && L ? g(i) : 0,
              N = !e && E ? g(l) : 0,
              F = V(O - N - (T + M));
            return (w && F > t + u && y.push(v), E && y.push(m.length), y);
          }, [])
          .map((y, v, w) => {
            const x = Math.max(w[v - 1] || 0);
            return m.slice(x, y);
          })
      : [];
  }
  function a(m) {
    return r ? p(m, c) : h(m);
  }
  return { groupSlides: a };
}
function At(n, t, c = "px") {
  const e = n.scroll === "x" ? u : d;
  let s = null,
    o = !1,
    i = !1;
  function l(a) {
    s !== a && ((s = a), (t.style.transform = a));
  }
  function u(a) {
    return `translate3d(${a}${c},0px,0px)`;
  }
  function d(a) {
    return `translate3d(0px,${a}${c},0px)`;
  }
  function b(a) {
    if (i || o === a) return;
    o = a;
    const f = a ? e(0) : "";
    l(f);
  }
  function g(a) {
    if (i) return;
    o || b(!0);
    const f = Rt(n.direction(a));
    l(e(f));
  }
  function r(a) {
    i = !a;
  }
  function p() {
    (l(""), t.getAttribute("style") || t.removeAttribute("style"));
  }
  return { set: l, clear: p, to: K(g), get: K(e), toggleActive: r, setIsScrolling: b };
}
function de(n, t, c, e, s, o, i, l, u, d, b, g) {
  const p = s ? [0, t, -t] : [0],
    h = L(),
    a = Dt(e.length - 1, 0, s);
  let f = u.get(),
    m = O(),
    y = m,
    v = [];
  function w(A, P) {
    const D = new Set(P);
    return A.filter((k) => !D.has(k));
  }
  function x(A, P) {
    return p.map((D) => ({ start: P - c[A] + -200 + D, end: P + n - -200 + D }));
  }
  function L() {
    return e.reduce((A, P, D) => Object.assign(Object.assign({}, A), { [D]: x(D, P) }), {});
  }
  function E(A, P) {
    return (D) => h[D].some(({ start: k, end: z }) => k < A && z > P);
  }
  function T(A, P, D, k) {
    const z = A.length > 0,
      G = z ? A[0] : P,
      $ = a.clone().set(G),
      X = () => $.add(D).get();
    for ($.set(X()); $.get() !== G; ) {
      const J = $.get(),
        q = k(J);
      if (!q && z) break;
      q && A.push(J);
      const Z = X();
      if (($.set(Z), s)) continue;
      const R = !Z,
        ot = vt(e, Z);
      if ((R && D === -1) || (ot && D === 1)) break;
    }
  }
  function O() {
    const A = [],
      P = i.slidesBySnap[o.get()];
    if (!P || !e.length) return A;
    const D = l.get(),
      k = u.get(),
      z = P[Math.floor(P.length / 2)],
      G = Math.max(D, k),
      $ = Math.min(D, k),
      X = E(G, $);
    return (X(z) && A.push(z), T(A, z, 1, X), T(A, z, -1, X), A);
  }
  function M(A) {
    ((m = O()), (v = w(y, m)), (y = m), (f = A));
  }
  function N(A, P) {
    P.forEach((D) => {
      const k = d[D],
        z = b.loopPoints[D];
      (s && z && z.target()) || k.setIsScrolling(A);
    });
  }
  function F(A) {
    const P = u.get();
    (!A && P === f) ||
      (M(P), !g.createEvent("scrolloptimize", { slidesInView: m, slidesLeftView: v }).emit()) ||
      (N(!0, m), N(!1, v));
  }
  return { optimize: F };
}
function he(n, t, c, e, s, o, i, l) {
  const {
      align: u,
      axis: d,
      direction: b,
      startSnap: g,
      loop: r,
      duration: p,
      dragFree: h,
      dragThreshold: a,
      inViewThreshold: f,
      inViewMargin: m,
      slidesToScroll: y,
      skipSnaps: v,
      containScroll: w,
      draggable: x,
      resize: L,
      slideChanges: E,
      focus: T,
    } = e,
    O = l ? 0 : 2,
    M = zt(d, b),
    { containerRect: N, slideRects: F } = i,
    H = M.getSize(N),
    A = Kt(H),
    P = jt(u, H),
    D = !r && !!w,
    k = r || !!w,
    { slideSizes: z, slideSizesWithGaps: G, startGap: $, endGap: X } = ue(M, N, F, c, k, s),
    J = fe(M, H, y, r, N, F, $, X, O),
    { snaps: q, snapsAligned: Z } = ne(M, P, N, F, J),
    R = -et(q) + et(G),
    { snapsContained: ot, scrollContainLimit: lt } = Jt(H, R, Z, w, O),
    _ = D ? ot : Z,
    { limit: tt } = Zt(R, _, r),
    Y = Dt(pt(_), g, r),
    Q = Y.clone(),
    at = dt(c),
    nt = Xt(),
    C = qt(
      () => nt.update(Lt),
      (Et) => nt.render(Lt, Et)
    ),
    S = 0.68,
    I = _[Y.get()],
    B = ut(I),
    j = ut(I),
    U = ut(I),
    W = ut(I),
    st = At(M, t),
    it = c.map((Et) => At(M, Et)),
    mt = ee(tt),
    rt = _t(B, U, j, W, p, S),
    yt = se(D, w, _, lt, J, at, mt),
    Ct = ce(H, R, z, G, q, _, U, it),
    Vt = de(H, R, G, q, r, Y, yt, U, W, it, Ct, o),
    wt = ie(r, _, R, tt, W),
    xt = oe(C, Y, Q, rt, wt, W, o),
    Mt = ht(),
    Ft = ae(t, c, o, f, m),
    kt = re(M, T, n, c, yt, xt, rt, Mt, o),
    Lt = {
      eventHandler: o,
      containerRect: N,
      contentSize: R,
      slideRects: F,
      nodeHandler: s,
      animation: C,
      slideSizes: z,
      isSsr: l,
      axis: M,
      dragHandler: Ut(x, M, n, W, Wt(M), B, C, xt, rt, wt, Y, o, A, h, a, v, S),
      eventStore: Mt,
      percentOfView: A,
      indexCurrent: Y,
      indexPrevious: Q,
      limit: tt,
      location: B,
      offsetLocation: U,
      previousLocation: j,
      options: e,
      resizeHandler: Qt(L, t, o, c, M, s),
      scrollBody: rt,
      scrollBounds: Yt(tt, U, W, rt, A),
      scrollLooper: te(R, tt, U, [B, U, j, W]),
      scrollProgress: mt,
      scrollSnaps: _,
      scrollTarget: wt,
      scrollTo: xt,
      slideLooper: Ct,
      slideFocus: kt,
      slidesHandler: le(E, t, o),
      slidesInView: Ft,
      slideIndexes: at,
      slidesToScroll: J,
      slideTranslates: it,
      scrollSnapList: yt,
      scrollOptimizer: Vt,
      translate: st,
      target: W,
    };
  return Lt;
}
function pe() {
  let n = {},
    t;
  function c(r) {
    t = r;
  }
  function e(r) {
    return n[r] || [];
  }
  function s(r, p) {
    return ((n = Object.assign(Object.assign({}, n), { [r]: p(e(r)) })), g);
  }
  function o(r, p) {
    return { api: t, type: r, detail: p };
  }
  function i(r, p) {
    return { api: t, emit: () => l(r, p) };
  }
  function l(r, p) {
    const h = o(r, p);
    return e(r).every((a) => a(t, h) !== !1);
  }
  function u(r, p) {
    return (s(r, (h) => (h.includes(p) ? h : [...h, p])), g);
  }
  function d(r, p) {
    return (s(r, (h) => h.filter((a) => a !== p)), g);
  }
  function b() {
    n = {};
  }
  const g = { init: c, clear: b, createEvent: i, on: u, off: d };
  return g;
}
const me = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  inViewMargin: "0px",
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startSnap: 0,
  active: !0,
  draggable: !0,
  resize: !0,
  focus: !0,
  slideChanges: !0,
  ssr: [],
};
function ge(n) {
  const t = n ? n.ownerDocument : null,
    c = t ? t.defaultView : null;
  let e;
  function s(g) {
    const { offsetTop: r, offsetLeft: p, offsetWidth: h, offsetHeight: a } = g;
    return { top: r, right: p + h, bottom: r + a, left: p, width: h, height: a };
  }
  function o(g, r, p) {
    if (p && e) return e;
    const h = n ? g.style : { transform: "" },
      a = h.transform;
    h.transform = "none";
    const f = s(g),
      m = r.map(s);
    return ((h.transform = a), (e = { containerRect: f, slideRects: m }), e);
  }
  function i(g, r, p, h) {
    return { offsetLeft: g, offsetTop: r, offsetWidth: p, offsetHeight: h };
  }
  function l(g) {
    const { container: r, slides: p } = g,
      a = (It(r) ? n.querySelector(r) : r) || n.children[0],
      f = It(p) ? a.querySelectorAll(p) : p,
      m = Array.from(f || a.children);
    return { root: n, container: a, slides: m };
  }
  function u(g) {
    const p = i(0, 0, 100, 100),
      h = p;
    let a = 0;
    const f = g.ssr.map((m) => {
      const y = i(a, a, m, m);
      return ((a += m), y);
    });
    return { root: p, container: h, slides: f };
  }
  function d(g) {
    return n ? l(g) : u(g);
  }
  return { ownerDocument: t, ownerWindow: c, getNodes: d, getRect: s, getRects: o };
}
function be() {
  let n;
  function t(i) {
    i && (n = i);
  }
  function c(i, l) {
    return Bt(i, l || {});
  }
  function e(i) {
    if (!n) return i;
    const l = i.breakpoints || {},
      u = gt(l)
        .filter((d) => n.matchMedia(d).matches)
        .map((d) => l[d])
        .reduce((d, b) => c(d, b), {});
    return c(i, u);
  }
  function s(i) {
    return n
      ? i
          .map((l) => gt(l.breakpoints || {}))
          .reduce((l, u) => l.concat(u), [])
          .map(n.matchMedia)
      : [];
  }
  return { init: t, mergeOptions: c, optionsAtMedia: e, optionsMediaQueries: s };
}
function Se(n) {
  let t = [];
  function c(o, i) {
    return (
      (t = i),
      i.reduce((l, u) => (u.init(o, n), Object.assign(Object.assign({}, l), { [u.name]: u })), {})
    );
  }
  function e() {
    t = t.filter((o) => o.destroy());
  }
  return { init: c, destroy: e };
}
function ve(n, t, c, e, s, o) {
  const i = At(t, n, "%");
  function l(b, g, r) {
    const { direction: p } = zt(b.axis, b.direction),
      { slides: h, container: a } = c.getNodes(b),
      { location: f, slideLooper: m, contentSize: y } = o(b, a, h),
      v = b.loop ? m.loopPoints : [],
      w = p(f),
      x = i.get(w),
      L = `${g}{transform:${x};}`,
      E = v.reduce((T, O) => {
        const { index: M } = O,
          N = St(O.target()),
          F = b.ssr[M];
        if (!N || !F) return T;
        const H = p((y / F) * 100 * N),
          A = i.get(H);
        return T + `${g} ${r}:nth-child(${M + 1}){transform:${A};}`;
      }, "");
    return L + E;
  }
  function u(b, g = "> *") {
    if (!e.ssr.length) return "";
    const r = e.breakpoints || {},
      p = l(e, b, g),
      h = Object.keys(r).reduce((a, f) => {
        const m = s(e, r[f]);
        return a + `@media ${f}{${l(m, b, g)}}`;
      }, "");
    return p + h;
  }
  return { getStyles: u };
}
function Ot(n, t, c) {
  const e = !n,
    s = be(),
    o = Se(s),
    i = ht(),
    l = pe(),
    { mergeOptions: u, optionsAtMedia: d, optionsMediaQueries: b } = s,
    { on: g, off: r, createEvent: p } = l,
    h = H;
  let a = !1,
    f,
    m,
    y,
    v = u(me, Ot.globalOptions),
    w = u(v),
    x = [],
    L = {},
    E,
    T,
    O;
  function M(C) {
    const S = u(w, C);
    return N(S, T, O, !0);
  }
  function N(C, S, I, B) {
    const U = u(C, e ? { direction: "ltr" } : {}),
      W = m.getRects(S, I, B),
      st = he(E, S, I, U, m, l, W, e);
    if (C.loop && !st.slideLooper.canLoop()) {
      const it = u(C, { loop: !1 });
      return N(it, S, I, !0);
    }
    return st;
  }
  function F(C, S) {
    if (a) return;
    m = ge(n);
    const { ownerWindow: I } = m;
    (s.init(I), (v = u(v, C)), (w = d(v)), (x = S || x));
    const B = m.getNodes(w);
    ((E = B.root),
      (T = B.container),
      (O = B.slides),
      (f = N(w, T, O)),
      (y = ve(T, f.axis, m, v, u, N)),
      b([v, ...x.map(({ options: j }) => j)]).forEach((j) => i.add(j, "change", H)),
      w.active &&
        (!e &&
          I &&
          (f.translate.to(f.location),
          f.scrollOptimizer.optimize(!0),
          f.options.loop && f.slideLooper.loop(),
          f.animation.init(I),
          f.resizeHandler.init(I),
          f.slidesInView.init(I),
          f.slidesHandler.init(I),
          f.slideFocus.init(I),
          f.eventHandler.init(nt),
          T.offsetParent && O.length && f.dragHandler.init(I)),
        (L = o.init(nt, x))));
  }
  function H(C, S) {
    const I = l.createEvent("reinit", null),
      B = R();
    (A(), F(u({ startSnap: B }, C), S), I.emit());
  }
  function A() {
    (f.dragHandler.destroy(),
      f.resizeHandler.destroy(),
      f.slidesHandler.destroy(),
      f.slidesInView.destroy(),
      f.animation.destroy(),
      o.destroy(),
      f.eventStore.clear(),
      i.clear(),
      f.translate.clear(),
      f.slideTranslates.forEach((C) => C.clear()));
  }
  function P() {
    if (a || e) return;
    const C = l.createEvent("destroy", null);
    ((a = !0), i.clear(), A(), C.emit(), l.clear());
  }
  function D(C, S, I) {
    a ||
      e ||
      (w.active &&
        (f.scrollBody.useBaseFriction().useDuration(S === !0 ? 0 : w.duration),
        f.scrollTo.index(C, I)));
  }
  function k(C) {
    D(q(1), C, -1);
  }
  function z(C) {
    D(q(-1), C, 1);
  }
  function G() {
    return q(1) !== R();
  }
  function $() {
    return q(-1) !== R();
  }
  function X(C, S) {
    return e ? y.getStyles(C, S) : "";
  }
  function J() {
    return f.scrollProgress.get(f.offsetLocation);
  }
  function q(C) {
    return f.indexCurrent.add(C).get();
  }
  function Z() {
    return f.scrollSnapList.progressBySnap;
  }
  function R() {
    return q(0);
  }
  function ot() {
    return f.indexPrevious.get();
  }
  function lt() {
    return f.slidesInView.get();
  }
  function _() {
    return L;
  }
  function tt() {
    return f;
  }
  function Y() {
    return E;
  }
  function Q() {
    return T;
  }
  function at() {
    return O;
  }
  const nt = {
    canGoToNext: G,
    canGoToPrev: $,
    cloneEngine: M,
    containerNode: Q,
    createEvent: p,
    internalEngine: tt,
    destroy: P,
    on: g,
    off: r,
    plugins: _,
    previousSnap: ot,
    reInit: h,
    rootNode: Y,
    goToNext: k,
    goToPrev: z,
    scrollProgress: J,
    goTo: D,
    selectedSnap: R,
    slideNodes: at,
    slidesInView: lt,
    snapIndex: q,
    snapList: Z,
    ssrStyles: X,
  };
  return (F(t || {}, c || []), nt);
}
Ot.globalOptions = void 0;
class ye extends $t {
  requiredRefs = ["viewport", "container"];
  embla = null;
  resizeObserver = null;
  mutationObserver = null;
  #t = null;
  #c = null;
  #e = null;
  #n = null;
  #l = !1;
  #a = !1;
  #s = !1;
  #p = 5e3;
  connectedCallback() {
    (super.connectedCallback(),
      this.#S(),
      this.refs.viewport.addEventListener("pointerdown", this.#v, { signal: this.signal }),
      window.addEventListener("pointerup", this.#m, { signal: this.signal }),
      window.addEventListener("pointercancel", this.#m, { signal: this.signal }),
      (this.resizeObserver = new ResizeObserver(() => {
        this.#u();
      })),
      this.resizeObserver.observe(this.refs.viewport),
      (this.mutationObserver = new MutationObserver((t) => {
        t.some((e) =>
          e.type !== "attributes" || e.attributeName !== "class" || !(e.target instanceof Element)
            ? !1
            : e.target.classList.contains("carousel-slide") || !!e.target.closest(".carousel-slide")
        ) && this.#u();
      })),
      this.mutationObserver.observe(this.refs.container, {
        attributes: !0,
        subtree: !0,
        attributeFilter: ["class"],
      }));
  }
  disconnectedCallback() {
    (super.disconnectedCallback(),
      this.embla?.destroy(),
      this.resizeObserver?.disconnect(),
      this.mutationObserver?.disconnect(),
      this.#D(),
      this.#t && clearTimeout(this.#t),
      this.#c && clearTimeout(this.#c));
  }
  get thumbnails() {
    return Array.isArray(this.refs.thumbnails) ? this.refs.thumbnails : [];
  }
  #S() {
    const t = {
      loop: this.dataset.loop !== "false",
      align: this.dataset.align || "start",
      containScroll: "trimSnaps",
      skipSnaps: !0,
      container: this.refs.container,
      slides: ".carousel-slide:not(.media-hidden):not(.is-hidden)",
      dragFree: this.dataset.dragFree === "true",
      slidesToScroll: parseInt(this.dataset.slidesToScroll) || 1,
      draggable: !0,
      resize: !0,
      focus: !0,
      slideChanges: !0,
    };
    ((this.embla = Ot(this.refs.viewport, t)),
      this.#y(),
      this.#x(),
      this.#I(),
      this.#E(),
      this.#A(),
      this.#o(),
      this.embla.on("select", () => this.#o()),
      this.embla.on("reinit", () => this.#o()),
      this.embla.on("scroll", () => this.#b()),
      this.embla.on("scrolloptimize", (c, e) => {
        const { willChange: s, translate3d: o } = e.detail;
        this.dataset.debug === "true" &&
          console.log("[Carousel] Scroll optimization:", { willChange: s, translate3d: o });
      }),
      (this.#c = setTimeout(() => {
        this.#o();
      }, 100)));
  }
  #u() {
    if (this.#l) {
      this.#a = !0;
      return;
    }
    (this.#t && clearTimeout(this.#t),
      (this.#t = setTimeout(() => {
        if (!this.isConnected || !this.embla) return;
        const t = this.embla.slideNodes(),
          c = t.filter(
            (u) =>
              u.offsetParent !== null &&
              !u.classList.contains("media-hidden") &&
              !u.classList.contains("is-hidden")
          ),
          e = typeof this.embla.selectedSnap == "function" ? this.embla.selectedSnap() : 0,
          s = t[e],
          o =
            s &&
            s.offsetParent !== null &&
            !s.classList.contains("media-hidden") &&
            !s.classList.contains("is-hidden"),
          i = c.length ? Math.max(0, t.indexOf(c[0])) : 0,
          l = o ? e : i;
        this.embla.reInit({ startSnap: l, draggable: !0, resize: !0, focus: !0, slideChanges: !0 });
      }, 50)));
  }
  #v = () => {
    this.#l = !0;
  };
  #m = () => {
    ((this.#l = !1), this.#a && ((this.#a = !1), this.#u()));
  };
  #o() {
    if (!this.embla) return;
    const t = this.embla.slideNodes().length;
    ((this.dataset.singleSlide = t <= 1 ? "true" : "false"),
      this.#w(),
      this.#g(),
      this.#T(),
      this.#L(),
      this.#b());
  }
  #y() {
    !this.refs.prev ||
      !this.refs.next ||
      !this.embla ||
      (this.refs.prev.addEventListener(
        "click",
        () => {
          this.embla && (this.embla.goToPrev(), this.#i());
        },
        { signal: this.signal }
      ),
      this.refs.next.addEventListener(
        "click",
        () => {
          this.embla && (this.embla.goToNext(), this.#i());
        },
        { signal: this.signal }
      ));
  }
  #w() {
    if (!this.refs.prev || !this.refs.next || !this.embla) return;
    const t = this.embla.slideNodes(),
      c = t.filter((u) => u.offsetParent !== null && !u.classList.contains("media-hidden"));
    if (c.length <= 1) {
      ((this.refs.prev.style.display = "none"), (this.refs.next.style.display = "none"));
      return;
    }
    if (!this.#r()) {
      ((this.refs.prev.style.display = "none"), (this.refs.next.style.display = "none"));
      return;
    }
    const s = this.embla.selectedSnap(),
      o = t[s];
    let i = c.indexOf(o);
    if (i < 0) {
      const u = c.map((b) => t.indexOf(b)).filter((b) => b >= 0);
      let d = 0;
      for (let b = 0; b < u.length; b++) u[b] <= s && (d = b);
      i = d;
    }
    if (this.dataset.loop !== "false") {
      ((this.refs.prev.style.display = ""), (this.refs.next.style.display = ""));
      return;
    }
    ((this.refs.prev.style.display = i <= 0 ? "none" : ""),
      (this.refs.next.style.display = i >= c.length - 1 ? "none" : ""));
  }
  #r() {
    if (!this.embla) return !0;
    if (
      this.embla
        .slideNodes()
        .filter(
          (l) =>
            l.offsetParent !== null &&
            !l.classList.contains("media-hidden") &&
            !l.classList.contains("is-hidden")
        ).length <= 1
    )
      return !1;
    const e = this.refs.viewport,
      s = this.refs.container,
      o = e?.clientWidth ?? 0;
    return o > 0 && s ? !(s.scrollWidth - o <= 1) : this.embla.snapList().length > 1;
  }
  #x() {
    !this.querySelector(".carousel-dots") || !this.embla || this.#g();
  }
  #g() {
    const t = this.querySelector(".carousel-dots");
    if (!t || !this.embla) return;
    const e = this.embla
        .slideNodes()
        .filter((g) => g.offsetParent !== null && !g.classList.contains("media-hidden")),
      o = this.embla.snapList().length;
    if (e.length <= 1) {
      t.style.display = "none";
      return;
    }
    if (!this.#r()) {
      t.style.display = "none";
      return;
    }
    t.style.display = "";
    const l = this.embla.selectedSnap(),
      u = Math.max(0, Math.min(l, o - 1)),
      d = Array.from(t.querySelectorAll(".carousel-dot"));
    if (d.length !== o)
      ((t.innerHTML = Array.from({ length: o }, (r, p) => {
        const h = p + 1,
          a = p === u,
          m = `carousel-snap-${p}`;
        return `<button
          type="button"
          class="carousel-dot${a ? " is-active" : ""}"
          role="tab"
          aria-label="Go to slide ${h}"
          aria-selected="${a ? "true" : "false"}"
          aria-controls="${m}"
          tabindex="${a ? "0" : "-1"}"
        ></button>`;
      }).join("")),
        Array.from(t.querySelectorAll(".carousel-dot")).forEach((r, p) => {
          r.addEventListener(
            "click",
            () => {
              this.embla && (this.embla.goTo(p), this.#i());
            },
            !1
          );
        }));
    else {
      const g = d;
      g.length > 0 &&
        g.forEach((r, p) => {
          const h = p === u;
          (r.setAttribute("aria-selected", String(h)), r.classList.toggle("is-active", h));
        });
    }
  }
  #L() {
    const { current: t, total: c } = this.refs;
    if (!t || !this.embla) return;
    const e = this.embla.slideNodes(),
      s = e.filter((d) => d.offsetParent !== null && !d.classList.contains("media-hidden")),
      o = this.querySelector(".carousel-counter")?.closest(".carousel-controls");
    if (o && s.length <= 1) {
      o.style.display = "none";
      return;
    }
    if (o) {
      if (!this.#r()) {
        o.style.display = "none";
        return;
      }
      o.style.display = "";
    }
    const i = e[this.embla.selectedSnap()],
      l = s.indexOf(i),
      u = s.length;
    (t instanceof HTMLElement && (t.textContent = String(l + 1)),
      c instanceof HTMLElement && (c.textContent = String(u)));
  }
  #E() {}
  #b() {
    const { progressbar: t } = this.refs;
    if (!t || !this.embla) return;
    const e = this.embla
        .slideNodes()
        .filter((u) => u.offsetParent !== null && !u.classList.contains("media-hidden")),
      s = this.querySelector(".carousel-progressbar")?.closest(".carousel-controls");
    if (s && e.length <= 1) {
      s.style.display = "none";
      return;
    }
    if (s) {
      if (!this.#r()) {
        s.style.display = "none";
        return;
      }
      s.style.display = "";
    }
    const o = this.embla,
      i = typeof o.scrollProgress == "function" ? o.scrollProgress() : null;
    let l = 0;
    if (typeof i == "number" && !Number.isNaN(i)) l = Math.max(0, Math.min(1, i)) * 100;
    else {
      const u = this.embla.snapList()?.length ?? 0,
        d = this.embla.selectedSnap?.() ?? 0;
      l = u > 1 ? (Math.max(0, Math.min(u - 1, d)) / (u - 1)) * 100 : 0;
    }
    t instanceof HTMLElement && (t.style.width = `${l}%`);
  }
  #I() {
    !this.thumbnails.length ||
      !this.embla ||
      this.thumbnails.forEach((t, c) => {
        t.addEventListener(
          "click",
          () => {
            if (!this.embla) return;
            const e = t.getAttribute("data-media-position");
            if (e) {
              const o = this.embla
                .slideNodes()
                .findIndex((i) => i.getAttribute("data-media-position") === e);
              if (o >= 0) {
                (this.embla.goTo(o), this.#i());
                return;
              }
            }
            (this.embla.goTo(c), this.#i());
          },
          { signal: this.signal }
        );
      });
  }
  #T() {
    if (!this.thumbnails.length || !this.embla) return;
    const t = this.embla.slideNodes(),
      c = this.embla.selectedSnap(),
      s = t[c]?.getAttribute("data-media-position") || null;
    this.thumbnails.forEach((i, l) => {
      const u = s ? i.getAttribute("data-media-position") === s : l === c;
      (i.setAttribute("aria-selected", String(u)),
        i.setAttribute("tabindex", u ? "0" : "-1"),
        i.classList.toggle("is-active", u));
    });
    const o =
      (s
        ? this.thumbnails.find((i) => i.getAttribute("data-media-position") === s)
        : this.thumbnails[c]) || null;
    o &&
      this.refs.thumbnailsContainer &&
      o.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  }
  #A() {
    this.dataset.autoplay !== "true" ||
      !this.embla ||
      this.embla.snapList().length <= 1 ||
      ((this.#s = !0),
      (this.#p = parseInt(this.dataset.autoplayDelay) || 5e3),
      this.refs.viewport.addEventListener(
        "pointerenter",
        () => {
          this.#d();
        },
        { signal: this.signal }
      ),
      this.refs.viewport.addEventListener(
        "pointerleave",
        () => {
          this.#O();
        },
        { signal: this.signal }
      ),
      this.#f());
  }
  #f() {
    !this.#s ||
      this.#e ||
      (this.#e = setInterval(() => {
        this.embla.canGoToNext() ? this.embla.goToNext() : this.embla.goTo(0);
      }, this.#p));
  }
  #d() {
    this.#e && (clearInterval(this.#e), (this.#e = null));
  }
  #D() {
    ((this.#s = !1), this.#d(), this.#h());
  }
  #i() {
    this.#s &&
      (this.#d(),
      this.#h(),
      (this.#n = setTimeout(() => {
        this.#f();
      }, 3e3)));
  }
  #O() {
    this.#s &&
      (this.#h(),
      (this.#n = setTimeout(() => {
        this.#f();
      }, 1e3)));
  }
  #h() {
    this.#n && (clearTimeout(this.#n), (this.#n = null));
  }
}
Ht("carousel-embla", ye);
